import { compose, withProps } from 'recompose';
import { routes } from '../../../../constants';
import CpdCategory from './partials/area-of-advice';

export default compose(
  withProps(() => ({
    parentPath: routes.app.training.home,
    parentName: 'CPD content',
    searchLabel: 'Search Items'
  })
  )
)(CpdCategory);


// WEBPACK FOOTER //
// ./src/containers/pages/app/training/training-area-of-advice.js